import template from './adpSearchInput.html';
import controller from './adpSearchInput.controller';
import './adpSearchInput.less';

let adpSearchInputComponent = {
  restrict: 'E',
  bindings: {
    placeholder: "@",
    hasBorder: "<"
  },
  template,
  controller
};

export default adpSearchInputComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpSearchInput/adpSearchInput.component.js